
export class SearchCustomerParam {
    public UserOfficeId: number;
    public officeId: number;
    public officeDesc: String;
    public saleCode?: string;
    public customerName?: string
    public isRental:boolean=false  //added by rahul yadav on 4/6/2021 incase of rental
    constructor() {
        this.UserOfficeId = 0 ;
        this.officeId = 0 ;
        this.officeDesc = "";
    }
}

export class PaymentAgingParam {
        public saleCode: string;    
        public officeId: number;
        public CompanyId: number;
        public customerName?: string;
    constructor() {
        this.saleCode = "";
        this.officeId = 0;
        this.CompanyId=  0;
    }
}
